export default __webpack_public_path__ + "static/media/navbar-hlr-dark.b2a1accd.svg";